// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//


import { QuoteModel } from "@insite/client-framework/Types/ApiModels";

export const getQuotePdfUrl = (quote: QuoteModel) => {
    if (!quote) {
        return "";
    }
    const quoteNumber = quote.erpOrderNumber || (quote as any).webOrderNumber
    return `/api/vmi/quoteAttachment/getPdf?quoteNumber=${quoteNumber}`;
};
